import React, { Component } from "react";
import AttachIcon from "./AttachIcon";
import { EmojiIcon } from "./EmojiIcon";
import { Picker } from "emoji-mart";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "./emoji-mart.css";
import "./dart_internal.css";
import { Tooltip } from "antd";

import {
  MAX_FILE_COMMENTS_IN_BYTES,
  MAX_FILE_COMMENTS_IN_MB
} from "../../utils/Constants/UploadsConstants";
import {
  uuidv4,
  handleFormat,
  sendNotification,
  getFileType,
  getFileName
} from "../../utils";
import UploadFile from "../../utils/UploadFile";

import AttachedFileProgress from "./AttachedFileProgress";
import {
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile
} from "../../actions/CommentAction";
import MainMentionInput2 from "./MainMentionInput2";
import { createComment } from "../../actions/CommentAction";

import { KEY_CODE_ENTER } from "../../utils";
class CommentAnswerInput extends Component {
  constructor(props) {
    super(props);
    this.uploadInputRef = React.createRef();
    this.state = {
      answerComments: {
        show: false,
        answer: "",
        commentId: null
      },

      mentionsAnswer: [],
      attachedFile: null,
      isUploadingFile: false,
      showEmojiPicker: false,
      isInputBoxWidthCalculated: false,
      inputBoxWidth: "0px"
    };
    this.myRef = React.createRef();
  }

  handleSelectFile = e => {
    const { intl } = this.props;
    const { length } = e.target.files;
    e.persist();
    const firstFilePosition = 0;
    if (
      length > 0 &&
      e.target.files[firstFilePosition].size <= MAX_FILE_COMMENTS_IN_BYTES
    ) {
      const ext = e.target.files[firstFilePosition].name.split(".").slice(-1);
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;
      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: e.target.files[firstFilePosition],
        name: e.target.files[firstFilePosition].name,
        size: e.target.files[firstFilePosition].size,
        sizeFormat: handleFormat(e.target.files[firstFilePosition].size),
        type: e.target.files[firstFilePosition].type,
        state: "waiting",
        progress: 0
      };
      let reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[firstFilePosition]);
      reader.onloadend = file => {
        if (file.total === 0) {
          console.log("problemas leyendo ");
        } else {
          this.setState({ attachedFile: newFile });
        }
      };
    } else if (
      e.target.files[firstFilePosition] &&
      e.target.files[firstFilePosition].size > MAX_FILE_COMMENTS_IN_BYTES
    ) {
      sendNotification(
        "error",
        intl,
        `${intl.formatMessage({
          id: "asset_exceeds_max_file"
        })}  ${MAX_FILE_COMMENTS_IN_MB} MB`
      );
    }
    this.uploadInputRef.current.value = "";
  };

  handleOnClickUploadFile = () => this.uploadInputRef.current.click();

  cleanAttachedFile = () => {
    this.setState({
      attachedFile: null,
      isUploadingFile: false
    });
  };
  cancelUpload = () => {
    const { attachedFile } = this.state;
    const { unsetIsDoingACommentWithFile, unsetIsAnswering } = this.props;
    attachedFile.uploadObject.abort();
    this.setState(
      (state, props) => {
        return {
          ...state,
          isUploadingFile: false,
          attachedFile: {
            ...state.attachedFile,
            progress: 0,
            state: "waiting",
            uploadObject: null
          }
        };
      },
      () => {
        unsetIsDoingACommentWithFile();
        unsetIsAnswering();
      }
    );
  };

  onClickUpload = () => {
    const { attachedFile } = this.state;
    const {
      user,
      clientId,
      clientName,
      setIsDoingACommentWithFile
    } = this.props;

    if (attachedFile) {
      setIsDoingACommentWithFile();
      const uploadFileObject = new UploadFile(clientId, clientName, user);
      uploadFileObject
        .checkIsSetAccelerateConfiguration()
        .then(() => {
          uploadFileObject.startUpload(
            attachedFile,
            this.setUploadObject,
            this.onProgressUpload,
            this.onSuccessUploadFile
          );
        })
        .catch(error => {
          console.error("error catch ", error);
        });
    } else {
      // console.log('seleccione archivo')
    }
  };

  onSuccessUploadFile = file => {
    const { unsetIsDoingACommentWithFile } = this.props;
    const formattedFile = {
      originalURL: file.futureFileURL,
      type: getFileType(file),

      name: getFileName(file),
      fileSize: file.size,
      fileSizeFormat: file.sizeFormat,
      uuid: file.uuid
    };
    this.handleSubmitCommentAnswer(formattedFile);

    this.cleanAttachedFile();
    unsetIsDoingACommentWithFile();
  };

  onProgressUpload = (file, e) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            state: "inprogress",
            progress: (e.loaded / e.total) * 100
          }
        };
      });
    }
  };

  setUploadObject = (file, uploadObject) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            uploadObject
          }
        };
      });
    }
  };

  handleOnSubmitComment = () => {
    const { attachedFile, isUploadingFile } = this.state;
    const { setIsAnswering } = this.props;

    if (attachedFile === null) {
      this.handleSubmitCommentAnswer();
    } else if (!isUploadingFile) {
      this.setState(
        {
          isUploadingFile: true
        },
        () => {
          this.onClickUpload();
        }
      );
    }
    setIsAnswering();
  };

  cleanAttachedFile = () => {
    this.setState({
      attachedFile: null,
      isUploadingFile: false
    });
  };

  handleOnClickUploadFile = () => {
    this.uploadInputRef.current.click();
  };

  onClickPickerEmojiComments = () => {
    this.setState(currentState => {
      return {
        showEmojiPicker: !currentState.showEmojiPicker
      };
    });
  };

  handleCommentAnswerTextChange = e => {
    this.setState(state => {
      const { answerComments } = state;
      return {
        isMainComment: 2,
        answerComments: {
          ...answerComments,
          answer: e.target.value
        }
      };
    });
  };

  addEmojiToCommentAnswer = item => {
    this.setState(state => ({
      ...state,
      answerComments: {
        ...state.answerComments,
        answer: `${state.answerComments.answer} ${item.native} `
      },
      showEmojiPicker: false
    }));
  };

  onAddMentionAnswer = (id, display) => {
    this.setState(state => ({
      mentionsAnswer: [
        ...state.mentionsAnswer.filter(r => r.id !== id),
        { id, display }
      ]
    }));
  };

  handleKeyDownAnswer = e => {
    const { answerComments } = this.state;
    if (!e.shiftKey) {
      if (e.keyCode === KEY_CODE_ENTER && answerComments.answer.trim()) {
        e.preventDefault();
        this.handleOnSubmitComment();
      }
    }
  };

  handleSubmitCommentAnswer = (fileToSend = null) => {
    const { answerComments, mentionsAnswer } = this.state;
    const {
      itemSelected,
      workclient,
      user,
      comment,
      afterSendAnswer
    } = this.props;
    let finalComment = "";
    let finalMentions = [];

    if (
      (itemSelected &&
        answerComments.answer &&
        answerComments.answer.length > 0) ||
      (itemSelected && fileToSend)
    ) {
      finalComment = answerComments.answer;

      const item = {
        position: comment ? comment.position + 1 : 1,
        numberReply: comment ? comment._id : null,
        versionId: null
      };

      finalMentions = mentionsAnswer
        .filter(r => finalComment.indexOf(`@[${r.display}](${r.id})`) > -1)
        .map(r => {
          if (finalComment.indexOf(`@[${r.display}](${r.id})`) > -1) {
            finalComment = finalComment.replace(
              `@[${r.display}](${r.id})`,
              r.display
            );
            return {
              user: r.id,
              nickName: r.display
            };
          }
          return null;
        });

      this.props.createComment(
        itemSelected.document._id,
        item.position,
        item.numberReply,
        finalComment,
        user._id,
        item.versionId,
        workclient,
        finalMentions,
        undefined,
        fileToSend
      );

      this.setState(
        {
          answerComments: {
            answer: "",
            commentId: null,
            show: false
          },
          mentionsAnswer: []
        },
        () => afterSendAnswer()
      );
    }
  };

  sendAudioMessage = audioData => {
    if (audioData) {
      const extInfo = audioData.type.split("/");
      const ext = extInfo[1];
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;

      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: audioData.blob,
        name: "usuario",
        size: audioData.blob.size,
        sizeFormat: handleFormat(audioData.blob.size),
        type: audioData.type,
        state: "waiting",
        progress: 0
      };

      this.setState({ attachedFile: newFile }, this.onClickUpload);
    }
  };
  componentDidMount() {
    const { isInputBoxWidthCalculated } = this.state;
    if (!isInputBoxWidthCalculated) {
      this.setState({ isInputBoxWidthCalculated: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { appWidth } = this.props;
    // const { isInputBoxWidthCalculated } = this.state
    const {
      isInputBoxWidthCalculated: prevIsInputBoxWidthCalculated
    } = prevState;
    if (
      this.myRef.current &&
      (!prevIsInputBoxWidthCalculated || appWidth !== prevProps.appWidth)
    ) {
      const inputBoxWidth = this.myRef.current.getBoundingClientRect().width;
      this.setState({ inputBoxWidth: `${inputBoxWidth}px` });
    }
  }

  render() {
    const {
      answerComments,
      attachedFile,
      isUploadingFile,
      showEmojiPicker,
      inputBoxWidth
    } = this.state;
    const { intl, usersMentions, comment } = this.props;
    const placeholderMessage = intl.formatMessage({ id: "write_a_answer" });

    return (
      <React.Fragment>
        <div className="c-answer__block" ref={this.myRef}>
          <div>
            <input
              type="file"
              onChange={this.handleSelectFile}
              ref={this.uploadInputRef}
              hidden
            />
            {attachedFile && (
              <AttachedFileProgress
                attachedFile={attachedFile}
                cancelUpload={this.cancelUpload}
                cleanAttachedFile={this.cleanAttachedFile}
                isUploadingFile={isUploadingFile}
              />
            )}
          </div>
          <div style={{ width: inputBoxWidth }}>
            <MainMentionInput2
              handleOnChangeInput={this.handleCommentAnswerTextChange}
              inputValue={answerComments.answer}
              handleKeyDown={this.handleKeyDownAnswer}
              placeholderValue={placeholderMessage}
              usersMentions={usersMentions}
              comment={comment}
              onAddHandler={this.onAddMentionAnswer}
              showAudioRecorder={true}
              sendAudioMessagehandler={this.sendAudioMessage}
            />
          </div>
          <div className="c-answer__block-actions">
            <div className="block-actions">
              <Tooltip placement="top" title="Emojis">
                <span
                  className={this.state.showEmojiPicker ? "active" : ""}
                  onClick={this.onClickPickerEmojiComments}
                >
                  <EmojiIcon />
                </span>
              </Tooltip>

              <Tooltip
                placement="top"
                title={intl.formatMessage({
                  id: "attach_file"
                })}
              >
                <span>
                  <AttachIcon onClick={() => this.handleOnClickUploadFile()} />
                </span>
              </Tooltip>
            </div>
            <div className="block-actions-buttons" style={{ display: "flex" }}>
              <div
                className="block-actions-button small"
                style={{
                  backgroundColor: "#081e33",
                  border: "1px solid #0096D6",
                  width: "110px",
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                onClick={() => this.props.afterSendAnswer()}
              >
                <span style={{ margin: "0px auto" }}>
                  {intl.formatMessage({ id: "cancel_button" })}
                </span>
              </div>
              <div
                className="block-actions-button small"
                onClick={this.handleOnSubmitComment}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <span style={{ margin: "0px auto" }}>
                  {intl.formatMessage({ id: "createCommentDart_permission" })}
                </span>
              </div>
            </div>
          </div>
          {showEmojiPicker && (
            <div
              className="dart-picker-emoji-answer"
              tabIndex="1"
              ref="divdartpickeremojianswer"
            >
              <Picker
                native={true}
                darkMode={true}
                showPreview={true}
                title={intl.formatMessage({
                  id: "set_emoji"
                })}
                emoji="point_up"
                autoFocus={true}
                perLine={12}
                onSelect={this.addEmojiToCommentAnswer}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    itemSelected: state.comments.itemSelected,
    workclient: state.client.workclient,
    appWidth: state.app.width
  };
};

const mapDispatchToProps = {
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile,
  createComment
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CommentAnswerInput))
);
